export enum CABIN_CLASS {
  ECONOMY = "ECONOMY",
  BUSINESS = "BUSINESS",
  FIRST_CLASS = "FIRST",
  PREMIUM_ECONOMY = "PREMIUM_ECONOMY",
}
